module.exports = __webpack_public_path__ + "img/62.58d26cfa.png";